import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { ComparisonCompareTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/comparisonCompare.trackingInfo";

import * as TrackingProductMapper from "../../mappers/product.mapper";
import * as TrackingService from "../../tracking.service";

export const track = (trackingInfo: ComparisonCompareTrackingInfo) => {
    const event: AnalyticsEvent<ComparisonCompareTrackingInfo> = {
        event: EventType.ComparisonCompare,
        payload: {
            eventData: trackingInfo
        }
    };

    TrackingService.track(event);
};

export const trackProducts = (
    products: Array<Product<ProductFieldSet.ProductTile>>
) => {
    const trackingProducts = products.map(
        TrackingProductMapper.toTrackingProduct
    );

    track({
        products: trackingProducts
    });
};
